/* =============================================
   Cart Restore Popup — assets/cart-restore-popup.js
   Indsæt reference i theme.liquid (før </body>):
   <script src="{{ 'cart-restore-popup.js' | asset_url }}" defer></script>
   ============================================= */

(function () {
  var STORAGE_KEY = 'crp_dismissed';
  var DELAY_MS = 1200; // Forsinkelse inden popup vises (ms)
  var DISMISS_HOURS = 24; // Timer inden popup kan vises igen

  function isDismissed() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var ts = parseInt(raw, 10);
      var hoursElapsed = (Date.now() - ts) / (1000 * 60 * 60);
      return hoursElapsed < DISMISS_HOURS;
    } catch (e) {
      return false;
    }
  }

  function dismiss() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
  }

  function closePopup(popup) {
    popup.querySelector('.crp-popup').style.opacity = '0';
    popup.querySelector('.crp-popup').style.transform = 
      window.innerWidth <= 480 
        ? 'translateY(30px)' 
        : 'translateX(-50%) translateY(-20px)';
    setTimeout(function () {
      popup.hidden = true;
    }, 350);
    dismiss();
  }

  function init() {
    var popup = document.getElementById('cart-restore-popup');
    if (!popup) return; // No cart items — Liquid didn't render the popup

    // Don't show if already dismissed recently
    if (isDismissed()) return;

    // Don't show on cart or checkout pages
    var path = window.location.pathname;
    if (path === '/cart' || path.indexOf('/checkout') === 0) return;

    // Show popup after delay
    setTimeout(function () {
      popup.hidden = false;
    }, DELAY_MS);

    // Close button
    var closeBtn = document.getElementById('crp-close-btn');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closePopup(popup);
      });
    }

    // Close on overlay click (outside popup)
    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        closePopup(popup);
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) {
        closePopup(popup);
      }
    });

    // Dismiss when clicking "Se kurv" or "Gå til kassen" (navigating away)
    var viewCart = document.getElementById('crp-view-cart');
    if (viewCart) {
      viewCart.addEventListener('click', function () {
        dismiss();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


  document.addEventListener('DOMContentLoaded', () => {
    const overlay = document.getElementById('cart-restore-popup');
    if (!overlay) return;

    const desktopMq = window.matchMedia('(min-width: 990px)');

    // Justér hvor langt man må scrolle før den lukker (px)
    const SCROLL_THRESHOLD_PX = 140;

    let armed = false;
    let startScrollY = 0;
    let wheelAccum = 0;

    const closePopup = () => {
      if (overlay.hasAttribute('hidden')) return;
      overlay.classList.add('is-closing');
      window.setTimeout(() => {
        overlay.setAttribute('hidden', '');
        overlay.classList.remove('is-closing');
        armed = false;
      }, 250);
    };

    const armAutoClose = () => {
      if (!desktopMq.matches) return;
      startScrollY = window.scrollY || 0;
      wheelAccum = 0;
      armed = true;
    };

    // Arm når popup bliver synlig (hidden fjernes af dit eksisterende popup-script)
    const obs = new MutationObserver(() => {
      const isVisible = !overlay.hasAttribute('hidden');
      if (isVisible) armAutoClose();
      else armed = false;
    });
    obs.observe(overlay, { attributes: true, attributeFilter: ['hidden'] });

    // Luk først efter man har scrollet et stykke på selve siden (desktop)
    window.addEventListener('scroll', () => {
      if (!desktopMq.matches || !armed) return;
      const delta = Math.abs((window.scrollY || 0) - startScrollY);
      if (delta >= SCROLL_THRESHOLD_PX) closePopup();
    }, { passive: true });

    // Trackpad/wheel: akkumuler scroll-intent og luk efter threshold
    window.addEventListener('wheel', (e) => {
      if (!desktopMq.matches || !armed) return;
      if (overlay.contains(e.target)) return; // scroller i popup -> luk ikke

      wheelAccum += Math.abs(e.deltaY || 0);
      if (wheelAccum >= SCROLL_THRESHOLD_PX) closePopup();
    }, { passive: true });

    // Hvis popup allerede er synlig ved load
    if (!overlay.hasAttribute('hidden')) armAutoClose();
  });